import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { LoanRequestMessageComponent } from 'src/app/MessageClipboard/loan-request-message/loan-request-message.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { LoanRequest } from 'src/model/loanRequest.model';

@Component({
    selector: 'app-review-loan-request',
    templateUrl: './review-loan-request.component.html',
    styleUrls: ['./review-loan-request.component.scss'],
    standalone: false
})
export class ReviewLoanRequestComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private datepipe = inject(DatePipe);

  @Input() requestList: LoanRequest[] = [];
  @Input() loanGroupId: number;
  @Input() disallowProcess = false;
  @Input() clashedTickets: LoanRequest[];

  disabledSubmit = false;
  relatedCustomerIds: number[];

  remark = "";

  ngOnInit(): void {

    this.relatedCustomerIds = (this.requestList != undefined) ? this.requestList.map(r => Number(r.CustomerId)) : [];

  }

  openShowWhatsappClipboardModal() {
    const modalRef = (this.sharedService.isAdmin() || this.sharedService.isBossAccount())
      ? this.sharedService.openModal(LoanRequestMessageComponent, "largeModal")
      : this.sharedService.openModal(LoanRequestMessageComponent);
    modalRef.componentInstance.requestList = this.requestList;
    modalRef.componentInstance.isEPFRequest = this.requestList[0].LoanInfo.Scheme == 'EPF';
    modalRef.componentInstance.loanGroupId = this.loanGroupId;
    // modalRef.componentInstance.previousEPFLoanList = this.previousEPFLoanList;
  }

  confirmBeforeVerifyOrUnverify(isVerify: boolean, index: number) {

    let errorMessage = "";
    if (this.requestList[index].LoanInfo.Scheme == 'EPF' && isVerify == true) {
      const isDOBValidWithIC = this.sharedService.isDOBValidWithIC(this.requestList[index].CustomerIC, new Date(this.requestList[index].DOB));
      const isEPFDateValid = this.sharedService.isEPFDateValid(new Date(this.requestList[index].DOB), new Date(this.requestList[index].EPFDate));

      if (isDOBValidWithIC == false)
        errorMessage += "Date Of Birth (" + this.datepipe.transform(this.requestList[index].DOB, "dd-MM-yyyy") + ") not same with IC (" + this.sharedService.processICNum(this.requestList[index].CustomerIC) + ") \n\n";

      if (isEPFDateValid == false) {
        const calculatedEPFDate = new Date(this.sharedService.calculateEPFDate(new Date(this.requestList[index].DOB)));
        errorMessage += "Calculated EPF Date (" + this.datepipe.transform(calculatedEPFDate, "dd-MM-yyyy") + ") not same with User defined EPF Date (" + this.datepipe.transform(this.requestList[index].EPFDate, "dd-MM-yyyy") + ")  \n\n";
      }

    }

    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    const verifyMessage = (isVerify == true) ? "VERIFY" : "UNVERIFY";
    modalRef.componentInstance.message = (errorMessage == "") ? "Confirm to " + verifyMessage + " this customer?" : "There are some error(s):\n" + errorMessage + "Confirm to " + verifyMessage + " this customer?";
    modalRef.result.then((confirm) => {
      if (confirm)
        this.verifyCutsomer(this.requestList[index].CustomerId, isVerify, index)
    });
  }

  verifyCutsomer(customerID: number, isVerify: boolean, index: number) {

    const xhr = (isVerify) ? this.restApi.postRequest(this.constructApi.getVerifyCustomer(customerID)) : this.restApi.postRequest(this.constructApi.getUnverifyCustomer(customerID));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {

        if (xhr.status == 200) {

          // window.location.reload();
          if (isVerify == true) {
            this.requestList[index].VerifiedOn = new Date();
            this.requestList[index].VerifiedBy = sessionStorage.getItem("username");
          } else {
            this.requestList[index].VerifiedOn = undefined;
            this.requestList[index].VerifiedBy = undefined;
          }

        } else
          this.sharedService.openErrorMessage(xhr);

      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
